import $ from 'jquery';

class ReviewerLockService {
  constructor() {
    this.baseURL = '/api/v1/reviewer_locks';
  }

  create(reviewUuid) {
    const url = this.baseURL;

    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        url,
        contentType: 'application/json',
        data: JSON.stringify({
          review_uuid: reviewUuid,
        }),
      }).done(resolve).fail(reject);
    });
  }
}

export default ReviewerLockService;
